/**
 * Article Video
 *
 * @author Rasmus Seindal <rseindal@vertic.com>
 */

import ServerView from '../../framework/server-side-view';
import GlueFrame from "glueframe";

const View = ServerView.extend({
    el: '.article.video',

    player: null,

    playButtonDirty: false,

    isVideo23: false,

    v23: false,

    // Allow for multiple youtube videos
    iframes: {},

    events: {
        'click button.play': 'playVideo',
        'click button.pause': 'pauseVideo',
    },

    initialize() {
        this.isVideo23 = this.el.classList.contains('video23');
        if (!this.isVideo23) {
            this.iframes[this.el.querySelector('iframe').id] = this;
            window.onYouTubePlayerAPIReady = this.onYouTubePlayerAPIReady.bind(this);
        } else {
            let iframeId = this.el.querySelector('iframe').id;
            this.v23 = new GlueFrame(document.getElementById(iframeId), "Player");
            //listen to end of the video
            var self = this;
            this.v23.bind("player:video:ended", function (eventName) {
                console.log("The event " + eventName);
                self.v23.set("currentTime", 0);
                self.pauseVideo();
            });
        }
    },

    onRender() {
        if (!this.isVideo23) this.injectYoutubeAPIScript();
    },

    injectYoutubeAPIScript() {
        const scriptId = 'YTS';

        if (!document.getElementById(scriptId)) {
            const tag = document.createElement('script');
            tag.id = scriptId;
            tag.src = '//www.youtube.com/player_api';
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    },

    onYouTubePlayerAPIReady() {
        const iframes = this.iframes;

        Object.keys(iframes).forEach(function (iframeId) {
            if (window.YT) {
                iframes[iframeId].player = new window.YT.Player(iframeId);
            }
        });

    },

    playVideo() {
        if (this.isVideo23) {
            this.v23.set("playing", true);
            this.el.querySelector('.article__mid-content__video-container__controls').classList.add('is-playing');
        } else {
            if (this.player && this.player.playVideo) {
                this.player.playVideo();
                this.el.querySelector('.article__mid-content__video-container__thumbnail').style.display = 'none';
            }
        }
    },

    pauseVideo() {
        if (this.isVideo23) {
            this.v23.set("playing", false);
            this.el.querySelector('.article__mid-content__video-container__controls').classList.remove('is-playing');
        }
    }
});

export default View;
